import { FormDataConsumer, required, TextInput } from "react-admin";
import React from "react";

const TYPE_OTHER = 3;

const ConferenceTypeOtherInput = (props) => (
  <FormDataConsumer {...props}>
    {({ formData }) => {
      if (!formData || formData.conference_type_id !== TYPE_OTHER) {
        return null;
      }
      return <TextInput {...props} validate={required()} maxLength={255} />;
    }}
  </FormDataConsumer>
);
export default ConferenceTypeOtherInput;
